import moment from "moment";
import React from 'react'
const json = {
    search: '',
    gender: '',
    id: '',
    admission_number:'',
    admission_id : '',
    search_admission : '',
    head_neck_remark:'',
    heart_lungs_remark:'',
    abdomen_pelvis_remark:'',
    extremities_remark:'',
    per_rectal_exam_remark:'',
    neurologic_remark:'',
    remark_secondary_survey:'',
    investigations:'',
    surname : '',
    name: '',
    citizen_id: '',
    address: '',
    telephone:'',
    email : '',
    blood_group : '',
    rh : '',
    remark : '',
    hn:'',
    birth_date:'',
    tambol_id:'',
    amphur_id:'',
    province_id:'',
    zipcode:'',
    timestamp:'',
    created_date:'',
    patient_found : false,
    patient_id : '',
    record_datetime :  moment(new Date()).format("DD-MM-YYYY H:mm"),
    age : 0,
    an : '',
    fractures_deformities_remark:'',
    division :'Trauma',
    staff_name :'',


    admission_date: moment(new Date()).format("DD-MM-YYYY"),
    discharge_date: moment(new Date()).format("DD-MM-YYYY"),
    chief_complaint:'',
    primary_a:'',
    primary_b:'',
    breathing_managements:'',
    hr:'',
    pr:'',
    bp_d:'',
    bp_s:'',
    bt:'',
    sat:'',
    primary_c:'',
    heart_sound:'',
    active_bleeding:'No',
    active_bleeding_remark:'',
    managements:'',
    inv_eFAST:'',
    inv_ekg:'',
    gcs_e:'',
    gcs_v:'',
    gcs_m:'',
    pupil_response:'',
    primary_e:'',
    spine_alignment:'',
    pr2:'',
    ng_og_tube:'',
    inv_p_cxr:'',
    abg:'',
    alcohol_history:'',
    medication:'',
    past_illness_pregnancy:'',
    events:'',
    last_meal:'',
    head_neck:'',
    heart_lungs:'',
    abdomen_pelvis:'',
    extremities:'',
    per_rectal_exam:'',
    neurologic:'',
    primary_diagnosis:'',
    other_problems:'',
    plan_of_managements:'',
    restriction_cspine_motion:'',
    airway_managements:'',
    fractures_deformities:'No',
    urethral_cath:'',
    allergy:'',
    height: '',
    weight: '',
    ward:'',
    staff_id :'',
    resident_name :'',
    record_name :'',
    recode_code :'',
    history:'',
    arrival_status : '',
    arrival_station : ''
    // admission_date: moment(new Date()).format("DD-MM-YYYY"),
    // discharge_date: moment(new Date()).format("DD-MM-YYYY"),
    // chief_complaint:'แผลฉีกขาดที่ใบหนา 30 นาที',
    // primary_a:'Normal : Patent airway, no obstruction, no abnormal sounds, no blood/secretion, no neck hematoma or laryngeal fracture, no subcutaneous emphysema',
    // primary_b:'Oxygen mask with bag',
    // breathing_managements:'Oxygen mask with bag',
    // hr:18,
    // pr:100,
    // rr:100,
    // bp_d:156,
    // bp_s:96,
    // bt:36.5,
    // sat:100,
    // primary_c:'Normal : Patent airway, no obstruction, no abnormal sounds, no blood/secretion, no neck hematoma or lary',
    // active_bleeding:'No',
    // managements:'test',
    // inv_eFAST:'test',
    // inv_ekg:'test',
    // gcs_e:4,
    // gcs_v:4,
    // gcs_m:4,
    // pupil_response:'3Test',
    // primary_e:'Normal : Patent airway, no obstruction, no abnormal soun',
    // pr2:'Normal : Patent airway, no obstruction, no abnormal soun',
    // ng_og_tube:'test',
    // inv_p_cxr:'test',
    // abg:'testabg',
    // alcohol_history:'Yes',
    // medication:'Normal : Patent airway, no obstruction, no abnormal soun',
    // past_illness_pregnancy:'Normal : Patent airway, no obstruction, no abnormal soun',
    // events:'Normal : Patent airway, no obstruction, no abnormal soun',
    // last_meal:'18:00',
    // head_neck:'unremarkable',
    // heart_lungs:'unremarkable',
    // abdomen_pelvis:'unremarkable',
    // extremities:'unremarkable',
    // per_rectal_exam:'unremarkable',
    // neurologic:'unremarkable',
    // primary_diagnosis:'unremarkable',
    // other_problems:'unremarkable',
    // plan_of_managements:'unremarkable',
    // restriction_cspine_motion:'Yes',
    // airway_managements:'unremarkable',
    // fractures_deformities:'No',
    // urethral_cath:'Test',
    // allergy:'Test',
    // height: 180,
    // weight: 88,
    // ward:'AE2',
    // staff_id :2,
    // resident_name :'TEST',
    // record_name :'TEST',
    // recode_code :'TEST',
    // history:'TEST',
}

export default json;
